"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkFriendshipStatus = exports.listFriendshipRequests = exports.listFriends = exports.removeFriend = exports.rejectFriendshipRequest = exports.cancelFriendshipRequest = exports.acceptFriendshipRequest = exports.createFriendshipRequest = void 0;
var axios_1 = __importDefault(require("axios"));
var catchAxiosError_1 = __importDefault(require("../../util/catchAxiosError"));
function createFriendshipRequest(_a) {
    var initiatorId = _a.initiatorId, targetId = _a.targetId, token = _a.token;
    return axios_1.default.post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/relations/add-friend"), { initiatorId: initiatorId, targetId: targetId, token: token }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}
exports.createFriendshipRequest = createFriendshipRequest;
function acceptFriendshipRequest(_a) {
    var initiatorId = _a.initiatorId, targetId = _a.targetId, token = _a.token;
    return axios_1.default.post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/relations/accept-friendship-request"), { initiatorId: initiatorId, targetId: targetId, token: token }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}
exports.acceptFriendshipRequest = acceptFriendshipRequest;
function cancelFriendshipRequest(_a) {
    var initiatorId = _a.initiatorId, targetId = _a.targetId, token = _a.token;
    return axios_1.default.post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/relations/cancel-friendship-request"), { initiatorId: initiatorId, targetId: targetId, token: token }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}
exports.cancelFriendshipRequest = cancelFriendshipRequest;
function rejectFriendshipRequest(_a) {
    var initiatorId = _a.initiatorId, targetId = _a.targetId, token = _a.token;
    return axios_1.default.post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/relations/reject-friendship-request"), { initiatorId: initiatorId, targetId: targetId, token: token }, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}
exports.rejectFriendshipRequest = rejectFriendshipRequest;
function removeFriend(_a) {
    var initiatorId = _a.initiatorId, targetId = _a.targetId, token = _a.token;
    // let formData = new FormData();
    // formData.append('initiator_userid', initiatorId);
    // formData.append('friend_userid', targetId);
    return axios_1.default.post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/relations/remove-friend"), {
        initiatorId: initiatorId,
        targetId: targetId,
        token: token
    });
}
exports.removeFriend = removeFriend;
function listFriends(_a) {
    var targetId = _a.targetId, token = _a.token;
    return axios_1.default
        .post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/relations/list-friends"), {
        targetId: targetId,
        token: token
    })
        .catch(catchAxiosError_1.default);
}
exports.listFriends = listFriends;
function listFriendshipRequests(_a) {
    var targetId = _a.targetId, token = _a.token;
    return axios_1.default
        .post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/relations/list-friendship-requests"), {
        targetId: targetId,
        token: token
    })
        .catch(catchAxiosError_1.default);
}
exports.listFriendshipRequests = listFriendshipRequests;
function checkFriendshipStatus(_a) {
    var targetId = _a.targetId, token = _a.token;
    return axios_1.default
        .post("".concat(process.env.REACT_APP_BACKEND_DOMAIN, "/api/v2/relations/check-friendship-status"), {
        targetId: targetId,
        token: token
    })
        .catch(catchAxiosError_1.default);
}
exports.checkFriendshipStatus = checkFriendshipStatus;
